import { render } from "./RareDiseaseDemographicBaseline.vue?vue&type=template&id=3d2f7a7d&scoped=true"
import script from "./RareDiseaseDemographicBaseline.vue?vue&type=script&lang=js"
export * from "./RareDiseaseDemographicBaseline.vue?vue&type=script&lang=js"

import "./RareDiseaseDemographicBaseline.vue?vue&type=style&index=0&id=3d2f7a7d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d2f7a7d"]])

export default __exports__